import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import { MEDIA_QUERIES, PriceAmounts } from '@sm360/widget-commons-general';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { PurchaseMethods, CurrencyFormats } from '@sm360/widget-commons-vehicle';

import CalculatorRebatesTradeIn from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorRebatesTradeIn/CalculatorRebatesTradeIn.jsx';

import 'payment-calculator/components/PaymentBar/PaymentBar.scss';

class PaymentBar extends React.Component {
    constructor(props) {
        super(props);

        this.handlePaymentCalculator = this.handlePaymentCalculator.bind(this);
    }

    handlePaymentCalculator() {
        this.props.setMobilePaymentCalculatorOpened(true);
    }

    render() {
        let apr = 0;
        let cashDown = 0;
        let months = '';
        let calculatedPaymentBeforeTaxes;
        let calculatedPaymentTaxes;
        let calculatedPayment;
        const creditRate = this.props.selectedFinanceTerm?.creditRate || 0;
        if (this.props.selectedFinanceTerm) {
            apr = this.props.selectedFinanceTerm.apr;
            if (this.props.displayCreditRate && creditRate) {
                apr = creditRate;
            }
            cashDown = this.props.selectedFinanceTerm
                ? LocaleService.l(this.props.selectedFinanceTerm.cashDown, CurrencyFormats.CURRENCY_0)
                : '';
            months = `/${this.props.selectedFinanceTerm.term} ${LocaleService.t(
                'PAYMENT_CALCULATOR.TERMLABELS.MONTHS'
            )}`;
            const calculatedPayments = this.props.selectedFinanceTerm.getCalculatedPayments(false);
            calculatedPaymentBeforeTaxes = calculatedPayments.calculatedPaymentBeforeTaxes;
            calculatedPaymentTaxes = calculatedPayments.calculatedPaymentTaxes;
            calculatedPayment = calculatedPayments.calculatedPayment;
        }

        const { disclaimers } = this.props.purchaseMethods;
        const taxCodes = this.props.purchaseMethods.getTaxCodesString() || LocaleService.t('taxes.taxes');
        const taxesDisclaimer =
            disclaimers && disclaimers.taxesExcluded
                ? disclaimers.taxesExcluded
                : LocaleService.t('PAYMENT_CALCULATOR.PAYMENTDISCLAIMERS.PLUSTAXES', { taxCodes });

        const calculatedFormattedPayments = {
            calculatedPaymentBeforeTaxes:
                calculatedPaymentBeforeTaxes > 0 ? (
                    <PriceAmounts price={LocaleService.l(calculatedPaymentBeforeTaxes, CurrencyFormats.CURRENCY_2)} />
                ) : (
                    ''
                ),
            calculatedPaymentTaxes:
                calculatedPaymentBeforeTaxes > 0 ? (
                    <PriceAmounts price={LocaleService.l(calculatedPaymentTaxes, CurrencyFormats.CURRENCY_2)} />
                ) : (
                    ''
                ),
            calculatedPayment:
                calculatedPaymentBeforeTaxes > 0 ? (
                    <PriceAmounts price={LocaleService.l(calculatedPayment, CurrencyFormats.CURRENCY_2)} />
                ) : (
                    ''
                ),
        };
        const paymentTaxesDisclaimer = (
            <>
                + {calculatedFormattedPayments.calculatedPaymentTaxes} ({taxCodes}) ={' '}
                {calculatedFormattedPayments.calculatedPayment}
            </>
        );

        const purchaseMethodLabels = this.props.purchaseMethods.getPurchaseMethodLabels(LocaleService);

        const calculatedPaymentSplit = this.props.selectedFinanceTerm
            ? PurchaseMethods.PurchaseMethodsService.getFormattedCurrencySplit(
                  LocaleService.l(this.props.selectedFinanceTerm.calculatedPayment, CurrencyFormats.CURRENCY_2)
              )
            : '';

        const navCashdown = !!cashDown && (
            <div className="paymentCalculator__cashdown-amount">
                <PriceAmounts price={cashDown} />
                <span>{LocaleService.t('PAYMENT_CALCULATOR.TERMLABELS.CASHDOWN')}</span>
            </div>
        );

        const rate = (
            <div className="paymentCalculator__interests">
                <span className="paymentCalculator__interests--amount">
                    {apr.toFixed(2).split('.')[0]}
                    <sup>
                        {apr.toFixed(2).split('.')[1]}% {this.props.displayCreditRate && 'APR'}
                    </sup>
                </span>
                <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                    <span className="paymentCalculator__interests--duration sr-mediumColor">{months}</span>
                </MediaQuery>
            </div>
        );

        const setPaymentLabel = !this.props.frequenciesPanelOpen
            ? 'PAYMENT_CALCULATOR.SET_PAYMENT'
            : 'PAYMENT_CALCULATOR.SAVE_PAYMENT';
        const iconPanel = !this.props.frequenciesPanelOpen ? 'icon-calculatrice' : 'icon-X-rouge';

        const paymentInfos = this.props.selectedFinanceTerm ? (
            <div className="paymentCalculator__paymentsInfos">
                <div className="paymentCalculator__title">
                    <span className="is-bold">{purchaseMethodLabels.verb}</span>
                    <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                        <span className="paymentCalculator__title--note is-light">
                            ({this.props.paymentFrequencyLabels.periodically})
                        </span>
                    </MediaQuery>
                    <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                        <span className="paymentCalculator__title--note is-light">{months}</span>
                    </MediaQuery>
                </div>
                <div>
                    <div className="paymentCalculator__paymentsWrapper">
                        <div className="paymentCalculator__payment">
                            <span className="is-util is-bold">
                                <PriceAmounts beforeDecimal={calculatedPaymentSplit.beforeDecimal} />
                            </span>
                            <sup className="is-util">
                                <PriceAmounts afterDecimal={calculatedPaymentSplit.afterDecimal} />
                            </sup>
                            <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                                <span className="paymentCalculator__title--note">
                                    ({this.props.paymentFrequencyLabels.periodically})
                                </span>
                            </MediaQuery>
                            <span className="paymentCalculator__payment--details is-light">
                                {paymentTaxesDisclaimer}
                            </span>
                        </div>
                        {rate}
                        {navCashdown}
                        {this.props.purchaseMethods.getSelectedPurchaseMethodAmounts().tradeIn > 0 &&
                            !this.props.purchaseMethods.cashPurchase.selected && (
                                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                                    <div className="paymentCalculator__tradeIn--term" onClick={this.showTradeInLabel}>
                                        <span>
                                            {LocaleService.t(
                                                'PAYMENT_CALCULATOR.CALCULATOR_REBATES_TRADEIN.TRADEIN_MOBILE'
                                            )}
                                        </span>
                                        {LocaleService.l(
                                            this.props.purchaseMethods.getSelectedPurchaseMethodAmounts().tradeIn,
                                            CurrencyFormats.CURRENCY_0
                                        )}
                                    </div>
                                </MediaQuery>
                            )}
                    </div>
                    <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                        <CalculatorRebatesTradeIn purchaseMethods={this.props.purchaseMethods} />
                    </MediaQuery>
                </div>
            </div>
        ) : (
            <div className="paymentCalculator__paymentsInfos">
                <div className="paymentCalculator__title is-bold">
                    {LocaleService.t('PAYMENT_CALCULATOR.CALCULATOR_REBATES_TRADEIN.SELLING_PRICE')}
                </div>
                <div>
                    <div className="paymentCalculator__paymentsWrapper">
                        <div className="paymentCalculator__payment">
                            <span className="is-util">
                                <PriceAmounts
                                    price={LocaleService.l(
                                        this.props.purchaseMethods.cashPurchase.getRetail() -
                                            this.props.purchaseMethods.cashPurchase.getTotalRebates(),
                                        CurrencyFormats.CURRENCY_0
                                    )}
                                />
                            </span>
                            <span className="paymentCalculator__payment--details sr-mediumColor">
                                {taxesDisclaimer}
                            </span>
                        </div>
                    </div>
                    <CalculatorRebatesTradeIn purchaseMethods={this.props.purchaseMethods} />
                </div>
            </div>
        );

        return (
            <div>
                <div className="sr-paymentCalculator-background">
                    <section className="paymentCalculator__wrapper">
                        {paymentInfos}
                        <div className="paymentCalculator__buttons">
                            <button
                                id="calculator-toggle-button"
                                className="sr-button-1 is-fluid"
                                onClick={this.handlePaymentCalculator}
                                aria-label={LocaleService.t(setPaymentLabel)}
                            >
                                <icon id="open-calculator" className={iconPanel} />
                                <span>{LocaleService.t(setPaymentLabel)}</span>
                            </button>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

PaymentBar.propTypes = {
    setMobilePaymentCalculatorOpened: PropTypes.func.isRequired,
    selectedFinanceTerm: ImmutablePropTypes.contains({
        paymentFrequency: PropTypes.number.isRequired,
        calculatedPayment: PropTypes.number.isRequired,
    }),
    paymentFrequencyLabels: PropTypes.shape({
        periodically: PropTypes.string.isRequired,
    }),
    frequenciesPanelOpen: PropTypes.bool.isRequired,
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel),
    displayCreditRate: PropTypes.bool,
};

PaymentBar.defaultProps = {
    paymentFrequencyLabels: [],
    displayCreditRate: false,
};

PaymentBar.displayName = 'PaymentBar';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethods,
        quote: state.quote,
    };
}

export default connect(mapStateToProps)(PaymentBar);
export { PaymentBar };
